(() => {
  let request;
  let serial = 0;
  const motionAllowed = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const celebrate = panel => {
    if (!motionAllowed() || typeof panel.animate !== 'function') return;
    panel.animate([{boxShadow:'0 0 0 0 #e1060066'},{boxShadow:'0 0 0 9px #e1060000'}],{duration:650});
    panel.querySelector('.kb-wholesale__copy')?.animate([{transform:'translateY(5px)',opacity:.5},{transform:'translateY(0)',opacity:1}],{duration:350,easing:'ease-out'});
    for (let i = 0; i < 14; i++) {
      const spark = document.createElement('span');
      spark.className = 'kb-wholesale__spark';
      spark.setAttribute('aria-hidden','true');
      panel.append(spark);
      const angle = i / 14 * Math.PI * 2;
      const animation = spark.animate([{transform:'translate(0,0)',opacity:1},{transform:`translate(${Math.cos(angle)*115}px,${Math.sin(angle)*85}px) rotate(${i*35}deg)`,opacity:0}],{duration:700,easing:'cubic-bezier(.15,.7,.3,1)'});
      animation.onfinish = () => spark.remove();
    }
  };
  const refresh = async () => {
    const hosts = [...document.querySelectorAll('[data-kb-wholesale-host]')];
    if (!hosts.length) return;
    request?.abort();
    request = new AbortController();
    const current = ++serial;
    const old = hosts.map(host => {
      const panel = host.querySelector('[data-kb-wholesale]');
      panel?.setAttribute('aria-busy','true');
      return { tier: Number(panel?.dataset.tier || 0), count: Number(panel?.dataset.count || 0), progress: Number(panel?.dataset.progress || 0) };
    });
    const root = window.Shopify?.routes?.root || hosts[0].querySelector('[data-kb-wholesale]')?.dataset.root || '/';
    const url = new URL(root, window.location.origin);
    url.searchParams.set('sections','katty-wholesale');
    try {
      const response = await fetch(url, { signal: request.signal, headers:{Accept:'application/json'}, cache:'no-store' });
      if (!response.ok) throw new Error('Wholesale section unavailable');
      const sections = await response.json();
      if (typeof sections['katty-wholesale'] !== 'string') throw new Error('Missing wholesale section');
      const parsed = new DOMParser().parseFromString(sections['katty-wholesale'],'text/html');
      const source = parsed.querySelector('[data-kb-wholesale-host]');
      if (!source) throw new Error('Missing wholesale markup');
      if (current !== serial) return;
      hosts.forEach((host,index) => {
        host.replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
        host.hidden = false;
        const panel = host.querySelector('[data-kb-wholesale]');
        if (!panel) return;
        const fill = panel.querySelector('.kb-wholesale__fill');
        const target = fill.style.getPropertyValue('--kb-wholesale-progress');
        if (motionAllowed()) {
          fill.style.setProperty('--kb-wholesale-progress',`${old[index].progress}%`);
          void fill.offsetWidth;
          requestAnimationFrame(() => fill.style.setProperty('--kb-wholesale-progress',target));
        }
        if (Number(panel.dataset.tier) > old[index].tier && panel.getClientRects().length) celebrate(panel);
      });
    } catch (error) {
      if (error.name !== 'AbortError' && current === serial) hosts.forEach(host => { host.hidden = true; });
    } finally {
      if (current === serial) document.querySelectorAll('[data-kb-wholesale]').forEach(panel => panel.removeAttribute('aria-busy'));
    }
  };
  document.addEventListener('kb:cart-updated',refresh);
  document.addEventListener('shopify:section:load',refresh);
})();

